import { useContext } from 'react';
import { AnalyticsContext } from '~/libs/analytics/components/Analytics';
import exceptionLogger from '~/libs/exception-logger';
import window from '~/libs/analytics/utils/global';

const isDataDogSynthetics = () => window._DATADOG_SYNTHETICS_BROWSER === true;

const useAnalytics = () => {
  const analytics = useContext(AnalyticsContext);
  if (analytics === undefined) {
    exceptionLogger().error(
      'Analytics context used outside of its Provider! Analytics will not work.',
    );
  }

  return !isDataDogSynthetics() && analytics ? analytics : null;
};

export default useAnalytics;
